import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useApprovalMatrixTypeReducer = () =>
  useSelector(
    (state: ApplicationState) => state.approvalMatrixType
  );